var map = {
  "./cs.json": [
    "aY",
    [
      "gs"
    ]
  ],
  "./en.json": [
    "aAK",
    [
      "g2"
    ]
  ],
  "./pl.json": [
    "mpZ",
    [
      "wwj"
    ]
  ],
  "./ru.json": [
    "xc",
    [
      "bzh"
    ]
  ],
  "./tr.json": [
    "HgL",
    [
      "5z"
    ]
  ],
  "./ja.json": [
    "wf5",
    [
      "q2"
    ]
  ],
  "./zh.json": [
    "FDD",
    [
      71
    ]
  ],
  "./pt-br.json": [
    "Pu0",
    [
      "ll"
    ]
  ],
  "./de.json": [
    "e8",
    [
      "0j8"
    ]
  ],
  "./es.json": [
    "Er",
    [
      "yq"
    ]
  ],
  "./fr.json": [
    "D8",
    [
      93
    ]
  ],
  "./it.json": [
    "EJb",
    [
      "i0"
    ]
  ],
  "./ko.json": [
    "gG",
    [
      "60px"
    ]
  ],
  "./pt.json": [
    "AI",
    [
      "u"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "GS";
module.exports = __rspack_async_context;
